import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button, HStack, Image, Stack, Text, VStack } from '@chakra-ui/react'
import { usePayment } from 'context'
import { PaymentSubscriptionType } from 'context/types'
import dayjs from 'dayjs'
import { themeColors } from 'theme'

import { CardBody, CardContainer } from 'components/CustomCard'
import VehicleInformation from 'components/VehicleInformation'
import formatter from 'utils/helpers/formatter'
import { DEFAULT_VEHICLE_IMAGE_URL } from 'utils/urls'

const { text: { smallText } } = themeColors

type SubscriptionInfoRouterProps = { subscription: PaymentSubscriptionType }

export const SubscriptionInfo = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const { paymentState: { state: { isPaidInstallation,
    paymentOptions: { data: { anualPayment, firstPayment, installation } } }
  } } = usePayment()

  const [subscription, setSubscription] = useState<PaymentSubscriptionType | null>(null)

  useEffect(() => {
    let subscription = null

    if (location.state) ({ subscription } = location.state as SubscriptionInfoRouterProps)
    setSubscription(subscription)
  }, [location])

  const handleNavigation = async () => {
    !true ? navigate('/contract-subscription', { state: { subscription } })
      : navigate('/billing', { state: { subscription } })
  }

  return (
    <CardContainer
      isScreen
      headerText='Resumen de la suscripción'
      onClose={() => navigate('/my-vehicles')}
      hiddenStack={false}>
      <CardBody isBorder >
        <VStack spacing={4} alignItems='flex-start' w='full'>
          <HStack>
            <Text>Plan premium</Text>
            <Text color={smallText}>
              {subscription?.subscriptionType === 'SUSCR-RENOV' ? '(renovación)' : '(primer año)'}
            </Text>
          </HStack>
          {subscription?.vehicle &&
            <HStack>
              <Text>
                {`Fecha de ${subscription.subscriptionType === 'SUSCR-RENOV' ? 'vencimiento' : 'contratación'}:`}
              </Text>
              <Text> {dayjs(subscription.paymentDate).format('DD MMM YYYY')}</Text>
            </HStack>
          }
          <HStack>
            <Text>Total a pagar:</Text>
            <Text>
              {subscription?.subscriptionType === 'SUSCR-RENOV'
                ? formatter.format(parseInt(anualPayment.amount ?? '120000'))
                : formatter.format(parseInt(
                  (isPaidInstallation ? installation.amount : firstPayment.amount) ?? '319990')
                )
              }
            </Text>
          </HStack>
        </VStack>
      </CardBody>
      <CardBody isBorder>
        <Text variant='MD_SB' textAlign='center'>Información del vehículo</Text>
        <HStack>
          <Stack direction={{ base: 'column', md: 'row' }} spacing={4}>
            <Image
              src={subscription?.vehicle
                ?  subscription.vehicle.mainImageUrl
                : DEFAULT_VEHICLE_IMAGE_URL
              } w={{ base: 'full', md: '50%' }} objectFit='contain' />
            <HStack w='full' justifyContent='center'>
              <VehicleInformation
                vehicle={subscription?.vehicle}
                plateNumber={subscription?.vin?.toUpperCase()}
                flexDir='column'
                isOnline={null} />
            </HStack>
          </Stack>
        </HStack>
      </CardBody>
      <Button w='full' maxW={{ base: 'full', md: 460 }} onClick={handleNavigation}>Siguiente</Button>
    </CardContainer>
  )
}
